<div class="dialog">
    <div class="suspend">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="71.375" viewBox="0 0 80 71.375">
            <g id="warning" transform="translate(-880 -296.937)">
                <path id="warning-2" data-name="warning"
                    d="M10.868,75.367h63.2a8.391,8.391,0,0,0,7.26-12.59l-31.6-54.6a8.389,8.389,0,0,0-14.52,0l-31.6,54.6a8.391,8.391,0,0,0,7.26,12.59Z"
                    transform="translate(877.531 292.944)" fill="#f7c600" />
                <path id="Union_36" data-name="Union 36"
                    d="M10779,15249.478a4,4,0,1,1,4,4A4,4,0,0,1,10779,15249.478Zm0-13.574v-15.394a4.2,4.2,0,1,1,8.395,0v15.394a4.2,4.2,0,0,1-8.395,0Z"
                    transform="translate(-9863 -14896.164)" fill="#fff" />
            </g>
        </svg>




        <h4 class="title mt-4"> {{data.title|translate}}</h4>
        <div class="hint">
            {{data.lable|translate}}</div>
        <div class="group_btn mt-3 justify-content-center">
            <button (click)="confirm()" mat-button class="btn_fill">{{"multiAuction.continue"|translate}}</button>
        </div>
    </div>
</div>